export async function getHarvestClientsByName(name, token) {
    const url = `api/client/findHarvestClientByNameContaining?name=${encodeURIComponent(name)}`
    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch HARVEST clients: ${response.status}`);
    }

    const data = await response.json();
    return data;
}

export async function getHarvestProjectsByClientID(clientId, token) {
    const url = `api/client/findHarvestProjectByClientId?clientId=${encodeURIComponent(clientId)}`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch JIRA projects: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function getHarvestProjectByProjectId(projectId, token) {
    const url = `api/client/findHarvestProjectByProjectId?projectId=${encodeURIComponent(projectId)}`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch JIRA projects: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function getHarvestTimeEntriesLastPeriod(projectId, periodBack, filterType, token){
    const url = `api/report/hours_last_period?projectId=${encodeURIComponent(projectId)}&periodBack=${encodeURIComponent(periodBack)}&filterType=${encodeURIComponent(filterType)}`

    const response = await fetch(url, {
        headers: {
            'Authorization' : 'Bearer ' + token,
            'Accept' : 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch last week's hours: ${response.status}`)
    }
    const data = await response.json();
    return data;
}

export async function getHarvestUserHoursLastMonth(serviceRequestId, token){
    const url = `api/harvest-tasks/${serviceRequestId}/findUserHoursByServiceRequestId`;
    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch JIRA projects: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getHarvestTasksHoursLastMonth(serviceRequestId, token) {
    const url = `api/harvest-tasks/${serviceRequestId}/findTaskHoursByServiceRequestId`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch JIRA projects: ${response.status}`);
    }
    const data = await response.json();
    return data;
}






